import { colorMap } from "./constants"
import { ScryfallCard } from "@scryfall/api-types";
import { StaticImageData } from "next/image";
import whitecreature from "@/assets/spellify/whitecreature.png"
import whitenoncreature from "@/assets/spellify/whitenoncreature.png"
import bluecreature from "@/assets/spellify/bluecreature.png"
import bluenoncreature from "@/assets/spellify/bluenoncreature.png"
import blackcreature from "@/assets/spellify/blackcreature.png"
import blacknoncreature from "@/assets/spellify/blacknoncreature.png"
import redcreature from "@/assets/spellify/redcreature.png"
import rednoncreature from "@/assets/spellify/rednoncreature.png"
import greencreature from "@/assets/spellify/greencreature.png"
import greennoncreature from "@/assets/spellify/greennoncreature.png"
import multicolorcreature from "@/assets/spellify/multicolorcreature.png"
import multicolornoncreature from "@/assets/spellify/multicolornoncreature.png"
import colorlesscreature from "@/assets/spellify/colorlesscreature.png"
import colorlessnoncreature from "@/assets/spellify/colorlessnoncreature.png"
import truecolorlesscreature from "@/assets/spellify/truecolorlesscreature.png"
import truecolorlessnoncreature from "@/assets/spellify/truecolorlessnoncreature.png"
import landcreature from "@/assets/spellify/landcreature.png"
import landnoncreature from "@/assets/spellify/landnoncreature.png"

const backgrounds: {[key: string]: StaticImageData} = {
    whitecreature, whitenoncreature,
    bluecreature, bluenoncreature,
    blackcreature, blacknoncreature,
    redcreature, rednoncreature,
    greencreature, greennoncreature,
    multicolorcreature, multicolornoncreature,
    colorlesscreature, colorlessnoncreature,
    truecolorlesscreature, truecolorlessnoncreature,
    landcreature, landnoncreature,
}

//card.color_identity - array
export function formatBackgroundURL(card: ScryfallCard.Normal, isHardMode: boolean) {
    const outType = card.power || card.toughness ? "creature" : "noncreature"
    var cid: string | undefined = ""
    if (isHardMode) {
        cid = "white"
    }
    else if (card.type_line.includes('Land')) {
        cid = "land"
    }
    else if (card.colors.length === 0) {
        cid = card.type_line.includes('Artifact') ? "colorless" : "truecolorless"
    } else if (card.colors.length > 1) {
        cid = "multicolor"
    }
    else if(card.colors[0] !== undefined){
        cid = colorMap[card.colors[0]]
    }
    return backgrounds[`${cid}${outType}`].src
}
